import {
  Box,
  getThemeColor,
  getThemeSpacing,
  Text,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

import { hexToRgba } from '../../../../utilities/colors/hexToRgba'

export const Container = styled(Box)<{ selected?: boolean }>`
  border-top: ${({ theme }) => `1px solid ${getThemeColor('grey_5', theme)}`};
  border-bottom: ${({ theme }) =>
    `1px solid ${getThemeColor('grey_5', theme)}`};
  gap: 10px;

  background-color: ${({ theme, selected }) =>
    selected
      ? hexToRgba(getThemeColor('secondary', theme), 0.08)
      : 'transparent'};

  cursor: pointer;
`

export const StyledRadio = styled.input.attrs({ type: 'radio' })`
  position: absolute;
  top: ${({ theme }) => getThemeSpacing(2, theme)};
  right: ${({ theme }) => getThemeSpacing(2, theme)};

  appearance: none;
  width: 20px;
  height: 20px;
  border: ${({ theme }) => `2px solid ${getThemeColor('secondary', theme)}`};
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: transparent;

  &:checked {
    border-color: ${({ theme }) => getThemeColor('secondary', theme)};
  }

  &:checked::after {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    background-color: ${({ theme }) => getThemeColor('secondary', theme)};
    border-radius: 50%;
    margin: auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  &:hover {
    border-color: ${({ theme }) => getThemeColor('secondary', theme)};
  }
`

export const OneLineText = styled(Text)`
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-transform: capitalize;
  }
`
